import { useEffect } from "react";
import DataTable from "react-data-table-component";
import { useAFBAdminTable } from "./hooks/useAFBAdminTable";
import { customStylesCompany } from "../../../util/TableStyles";
import { noDataComponent } from "../../../util/DataObject";
import { Card, Skeleton, FlexGrid, Typography, useThemeProvider } from "@albo-ui/core";
import CustomSearchBar from "../../elements/SearchBar/CustomSearchBar";
import CustomPagination from "../../elements/CustomPagination";
import PeopleIcon from "@mui/icons-material/People";
import { AfbAdminDetail } from "./AfbAdminDetail";
import GeneralConfirmDialog from "../../modals/confirm/GeneralConfirmDialog";

export const AfbAdminList = ({changeAlert, changeLoader, sectionData, config, catalogs}: any) => {
    const { data, admin, afbNewActions, action, columns, loading: loadingTable, loadingExecute, pagination, item, element, dialogText, dialogProps, onOpenConfirm, otpTokenGetAllowed, dataReuse, saveData, changePage, handleChangeRowsPerPage, onOpenAdminCreate, onOpenDetail, onHandleSearch, onHandleWidgetChange, onHandleUpdate, onHandleUpdateStatus, onHandleCreate, onHandleConfirm, onCloseDialogConfirm, DialogConfirm} = useAFBAdminTable(changeAlert, config);
    const { theme } = useThemeProvider();

    useEffect(() => {
        saveData(sectionData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(() => {
        changeLoader(loadingTable || loadingExecute);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadingTable, loadingExecute]);

    return (
        <>
            {!admin && <Card padding={4} flexDirection="column" fullWidth fullHeight alignItems="stretch" justifyContent="space-between" style={{ borderColor: theme.colors.manatee}}>
                <FlexGrid container fullWidth justify="space-between" style={{ marginBottom: 25, display: "flex" }}>
                    {loadingTable || loadingExecute ? (
                        <Skeleton width="100%" height="100px" style={{ marginTop: 20 }}/>
                    ) : (
                        <>
                            <FlexGrid item justify="space-between" fullWidth>
                                <Typography variant="h2" style={{display: "flex", alignItems: "center", fontSize: "1.2rem"}}>
                                    <PeopleIcon sx={{ marginRight: 1 }} />Administradores aFB
                                </Typography>
                            </FlexGrid>
                            <FlexGrid item fullWidth>
                                <CustomSearchBar
                                    field={true}
                                    button={sectionData["content"]["userList"] && {
                                        width: 150,
                                        text: "Crear",
                                        onHandle: onOpenAdminCreate
                                    }}
                                    refresh
                                    refreshType2
                                    onConfirm={onHandleSearch}
                                    textField={"Buscar usuario por email o teléfono..."}
                                />
                            </FlexGrid>
                        </>
                    )}
                </FlexGrid>


                <FlexGrid container style={{ margin: "25px 0" }} direction="column">
                    {loadingTable || loadingExecute ? (
                        <Skeleton width="100%" height="100px" />
                    ) : (
                        <DataTable
                            data={data["users"]}
                            columns={columns}
                            customStyles={customStylesCompany}
                            noDataComponent={noDataComponent}
                        />
                    )}
                </FlexGrid>
                <CustomPagination
                    rows={pagination.totalDocuments}
                    page={pagination.page}
                    rowsPerPage={pagination.rowsPerPage}
                    handleChangePage={changePage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Card>}
            {admin && <AfbAdminDetail
                sectionData={admin}
                roles={data["roles"]}
                action={action}
                config={config}
                catalogs={catalogs}
                afbNewActions={afbNewActions}
                onHandleWidgetChange={onHandleWidgetChange}
                onHandleUpdate={onHandleUpdate}
                onHandleUpdateStatus={onHandleUpdateStatus}
                onHandleCreate={onHandleCreate}
                onOpenConfirm={onOpenConfirm}
                onOpenDetail={onOpenDetail}
                otpTokenGetAllowed={otpTokenGetAllowed}
                dataReuse={dataReuse}
                changeAlert={changeAlert}
                changeLoader={changeLoader}
            />}

            <GeneralConfirmDialog 
                open={dialogProps.open}
                text={dialogText}
                onClose={onCloseDialogConfirm} 
                onConfirm={onHandleConfirm.bind(this)} 
                item={item}
                element={element}
            />
            <DialogConfirm />
        </>
    );
};
